import { BrowserRouter, Route, Routes } from "react-router-dom"
import NotFound404 from "../pages/NotFound404";
import Login from '../pages/Login';
import LoginCheck from "../pages/LoginCheck";
import UnAuthorized from "../pages/UnAuthorized";
import DashboardRouter from "./Dashboard";
import TestLayout from "../pages/TestLayout";
import RequestRouter from "./RequestRouter";
import SettingsRouter from "./SettingsRouter";
import ApproverRouter from "./ApproverRouter";
import AdminRouter from "./AdminRouter";
import LimitedOpexRouter from "./LimitedOpexRouter";

const RootRouter = () => {
    return (
        <BrowserRouter>            
            <Routes>
                <Route path="/" element={<DashboardRouter />} />
                <Route path="/admin/*" element={<AdminRouter />} />
                <Route path="/approver/*" element={<ApproverRouter />} />
                <Route path="/limited/*" element={<LimitedOpexRouter />} />
                <Route path="/request/*" element={<RequestRouter />} />
                <Route path="/settings/*" element={<SettingsRouter />} />
                <Route path="/login" element={<Login />} />
                <Route path="/check-login" element={<LoginCheck />} />
                <Route path="/unauthorized" element={<UnAuthorized />} />
                <Route path="/test" element={<TestLayout />} />
                <Route path="*" element={<NotFound404 />} />
            </Routes>
        </BrowserRouter>
    )
}

export default RootRouter;